import { Component, Injector, Input, OnInit } from '@angular/core';
import { CheckboxControlSchema, CustomControlSchema, DataFormBase, EditorControlSchema, EventData, FormSchemaBase, FormState, TextAreaControlSchema, TextControlSchema } from 'tnx-shared';
import { EmailSenderService } from 'tnx-admin-service/app-settings/email-sender/services';

@Component({
    selector: 'test-email-sender',
    templateUrl: './test-email-sender.component.html',
    styleUrls: ['./test-email-sender.component.scss']
})
export class TestEmailSenderComponent extends DataFormBase implements OnInit {

    currentIndex = -1;

    get labelButton() {
        return `Đổi email (STT: ${this.currentIndex + 1})`;
    }

    constructor(
        private _emailSenderService: EmailSenderService,
        _injector: Injector
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._emailSenderService;
        this.model.formState = FormState.ADD;

        this.setting.schema = <FormSchemaBase[]>[
            new CheckboxControlSchema({
                field: 'customSendTestEmail',
                label: 'Tùy chỉnh thông tin gửi test email (mặc định lấy thông tin khai báo ở cấu hình gửi email)',
                mdWidth: 9,
                showLabel: false,
                onChanged: (eventData: EventData) => {
                    this.toggleDisableControl(eventData.formControls, !eventData.parentModel.customSendTestEmail);
                }
            }),
            new CheckboxControlSchema({
                field: 'enableSsl',
                label: 'Sử dụng Ssl',
                mdWidth: 3,
                disabled: true,
                showLabel: false
            }),
            new TextControlSchema({
                field: 'server',
                label: 'Server SMTP (smtp.gmail.com, smtp.office365.com...)',
                required: true,
                mdWidth: 6,
                disabled: true
            }),
            new TextControlSchema({
                field: 'port',
                label: 'Cổng (587, 465...)',
                dataFormat: 'number',
                required: true,
                min: 1,
                mdWidth: 6,
                disabled: true
            }),
            new CustomControlSchema({
                field: 'btnSelectEmail',
                mdWidth: 3
            }),
            new TextControlSchema({
                field: 'emailFrom',
                label: 'Email sender',
                required: true,
                mdWidth: 5,
                disabled: true
            }),
            new TextControlSchema({
                field: 'emailFromPassword',
                label: 'Mật khẩu email sender',
                required: true,
                mdWidth: 4,
                disabled: true,
                dataFormat: 'password'
            }),
            new TextControlSchema({
                field: 'emailTo',
                label: 'Danh sách email nhận (mỗi email cách nhau bởi dấu phảy)',
                required: true,
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'subject',
                label: 'Tiêu đề email test',
                required: true,
                mdWidth: 12,
                disabled: true
            }),
            new EditorControlSchema({
                field: 'body',
                label: 'Nội dung email test',
                required: true,
                mdWidth: 12,
                disabled: true
            }),
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        formEvent.model.enableSsl = true;
        formEvent.model.server = this.parentModel.data.server;
        formEvent.model.port = this.parentModel.data.port;
        const emailAccount = this.getEmailToSendFromList();
        formEvent.model.emailFrom = emailAccount.emailFrom;
        formEvent.model.emailFromPassword = emailAccount.emailPassword;
        formEvent.model.subject = `[Thử nghiệm] Chức năng gửi email thử nghiệm`;
        formEvent.model.body = `<b>Vui lòng không phản hồi email thử nghiệm này. Xin trân trọng cảm ơn!</b>`;
        console.log(this.model.data);
    }

    toggleDisableControl(formControls: FormSchemaBase[], state: boolean) {
        formControls['enableSsl'].disabled = state;
        formControls['server'].disabled = state;
        formControls['port'].disabled = state;
        formControls['emailFrom'].disabled = state;
        formControls['emailFromPassword'].disabled = state;
        formControls['subject'].disabled = state;
        formControls['body'].disabled = state;
    }

    getEmailToSendFromList() {
        if (this.parentModel.data.account.length == 0) { return {}; }
        this.currentIndex++;
        if (this.currentIndex > this.parentModel.data.account.length - 1) {
            this.currentIndex = 0;
        }
        return this.parentModel.data.account[this.currentIndex];
    }

    changeEmail() {
        const emailAccount = this.getEmailToSendFromList();
        this._setModelValue('emailFrom', emailAccount.emailFrom);
        this._setModelValue('emailFromPassword', emailAccount.emailPassword);
    }

    sendTest() {
        this.model.submitting = true;
        this._emailSenderService.sendTestEmail(this.model.data).then(rs => {
            this.model.submitting = false;
            if (rs.success) {
                this._notifierService.showSuccess('Gửi email test thành công!');
            } else {
                this._notifierService.showWarning(rs.error);
            }
        }).catch(err => {
            console.error(err);
            this._notifierService.showWarning('Có lỗi xảy ra, vui lòng liên hệ quản trị để biết thêm chi tiết')
            this.model.submitting = false;
        });
    }
}
